// @flow

import type {RowHoverParams} from '../typedef';

type RowHover = {|
    onMouseEnter?: () => void,
    onMouseLeave?: () => void,
|};

export const getRowHover = (params: RowHoverParams): RowHover => {
    const {fixed, pinned, disabledHover, id, setRowHover, removeRowHover} = params;
    const rowHover = {};
    if (fixed && !disabledHover) {
        rowHover.onMouseEnter = () => setRowHover(id, {fixed, pinned});
        rowHover.onMouseLeave = () => removeRowHover(id, {fixed, pinned});
    }
    return {...rowHover};
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
